import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=3fafcc45"
import script from "./AddCard.vue?vue&type=script&lang=ts"
export * from "./AddCard.vue?vue&type=script&lang=ts"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=3fafcc45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports